import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import { Shield, Droplets, Sparkles, Phone, Mail, User, MessageSquare, CheckCircle } from 'lucide-react';
import { CONTACT } from '../data/constants';

const ChemicalsPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
    productInterest: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const products = [
    {
      name: 'Spa Chlorine Granules',
      description: 'Fast-dissolving chlorine granules for hot tub sanitization. Kills bacteria and keeps your water crystal clear.',
      price: '$24.95',
      image: 'https://customer-assets.emergentagent.com/job_river-spa-catalog/artifacts/qcp7yp8w_SWIM%20SPAS%20SIMPSONVILLE%20SC%2C%20SWIM%20SPAS%20GREENVILLE%20SC%2C%20SWIM%20SPAS%2C%20SWIM%20SPAS%20IN%20GREENVILLE%20SC%2C-2.avif',
      category: 'Sanitizers'
    },
    {
      name: 'Spa Bromine Tablets',
      description: 'Long-lasting bromine tablets for continuous sanitization. Ideal for sensitive skin and produces less odor than chlorine.',
      price: '$34.95',
      image: 'https://customer-assets.emergentagent.com/job_river-spa-catalog/artifacts/qcp7yp8w_SWIM%20SPAS%20SIMPSONVILLE%20SC%2C%20SWIM%20SPAS%20GREENVILLE%20SC%2C%20SWIM%20SPAS%2C%20SWIM%20SPAS%20IN%20GREENVILLE%20SC%2C-2.avif',
      category: 'Sanitizers'
    },
    {
      name: 'pH Increaser',
      description: 'Raises pH levels to the ideal range for comfortable soaking. Prevents corrosion and scale buildup.',
      price: '$14.95',
      image: 'https://customer-assets.emergentagent.com/job_river-spa-catalog/artifacts/qcp7yp8w_SWIM%20SPAS%20SIMPSONVILLE%20SC%2C%20SWIM%20SPAS%20GREENVILLE%20SC%2C%20SWIM%20SPAS%2C%20SWIM%20SPAS%20IN%20GREENVILLE%20SC%2C-2.avif',
      category: 'Balancers'
    },
    {
      name: 'pH Decreaser',
      description: 'Lowers pH levels for optimal water balance. Improves sanitizer effectiveness and bather comfort.',
      price: '$12.95',
      image: 'https://customer-assets.emergentagent.com/job_river-spa-catalog/artifacts/qcp7yp8w_SWIM%20SPAS%20SIMPSONVILLE%20SC%2C%20SWIM%20SPAS%20GREENVILLE%20SC%2C%20SWIM%20SPAS%2C%20SWIM%20SPAS%20IN%20GREENVILLE%20SC%2C-2.avif',
      category: 'Balancers'
    },
    {
      name: 'Alkalinity Increaser',
      description: 'Raises total alkalinity to prevent pH fluctuations. Essential for stable water chemistry.',
      price: '$16.95',
      image: 'https://customer-assets.emergentagent.com/job_river-spa-catalog/artifacts/qcp7yp8w_SWIM%20SPAS%20SIMPSONVILLE%20SC%2C%20SWIM%20SPAS%20GREENVILLE%20SC%2C%20SWIM%20SPAS%2C%20SWIM%20SPAS%20IN%20GREENVILLE%20SC%2C-2.avif',
      category: 'Balancers'
    },
    {
      name: 'Spa Shock Treatment',
      description: 'Powerful oxidizer that eliminates organic contaminants and restores water clarity. Use weekly for best results.',
      price: '$19.95',
      image: 'https://customer-assets.emergentagent.com/job_river-spa-catalog/artifacts/qcp7yp8w_SWIM%20SPAS%20SIMPSONVILLE%20SC%2C%20SWIM%20SPAS%20GREENVILLE%20SC%2C%20SWIM%20SPAS%2C%20SWIM%20SPAS%20IN%20GREENVILLE%20SC%2C-2.avif',
      category: 'Shock'
    },
    {
      name: 'Foam Reducer',
      description: 'Quickly eliminates unsightly foam caused by lotions, soaps, and body oils. Safe for all spa surfaces.',
      price: '$11.95',
      image: 'https://customer-assets.emergentagent.com/job_river-spa-catalog/artifacts/qcp7yp8w_SWIM%20SPAS%20SIMPSONVILLE%20SC%2C%20SWIM%20SPAS%20GREENVILLE%20SC%2C%20SWIM%20SPAS%2C%20SWIM%20SPAS%20IN%20GREENVILLE%20SC%2C-2.avif',
      category: 'Specialty'
    },
    {
      name: 'Scale & Stain Preventer',
      description: 'Prevents calcium scale buildup and metal staining. Protects your spa equipment and surfaces.',
      price: '$18.95',
      image: 'https://customer-assets.emergentagent.com/job_river-spa-catalog/artifacts/qcp7yp8w_SWIM%20SPAS%20SIMPSONVILLE%20SC%2C%20SWIM%20SPAS%20GREENVILLE%20SC%2C%20SWIM%20SPAS%2C%20SWIM%20SPAS%20IN%20GREENVILLE%20SC%2C-2.avif',
      category: 'Specialty'
    },
    {
      name: 'Water Clarifier',
      description: 'Clears cloudy water by coagulating tiny particles for easy filtration. Restores sparkling clarity.',
      price: '$13.95',
      image: 'https://customer-assets.emergentagent.com/job_river-spa-catalog/artifacts/qcp7yp8w_SWIM%20SPAS%20SIMPSONVILLE%20SC%2C%20SWIM%20SPAS%20GREENVILLE%20SC%2C%20SWIM%20SPAS%2C%20SWIM%20SPAS%20IN%20GREENVILLE%20SC%2C-2.avif',
      category: 'Specialty'
    },
    {
      name: 'Test Strips (50 count)',
      description: 'Easy-to-use test strips for checking chlorine/bromine, pH, alkalinity, and hardness levels.',
      price: '$15.95',
      image: 'https://customer-assets.emergentagent.com/job_river-spa-catalog/artifacts/qcp7yp8w_SWIM%20SPAS%20SIMPSONVILLE%20SC%2C%20SWIM%20SPAS%20GREENVILLE%20SC%2C%20SWIM%20SPAS%2C%20SWIM%20SPAS%20IN%20GREENVILLE%20SC%2C-2.avif',
      category: 'Testing'
    }
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    // In a real app, this would send to a backend
    console.log('Form submitted:', formData);
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 5000);
    setFormData({ name: '', email: '', phone: '', message: '', productInterest: '' });
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <>
      <Helmet>
        <title>Spa Chemicals | Leisure Wellness Naples</title>
        <meta name="description" content="Premium hot tub and spa chemicals for water care. Chlorine, bromine, pH balancers, shock treatments, and more. Contact us for pricing and availability." />
      </Helmet>
      <div className="pt-36 pb-20" style={{ background: 'linear-gradient(180deg, #ffffff 0%, #E0FFFF 20%, #AFEEEE 50%, #98FB98 80%, #F0FFF0 100%)' }} data-testid="chemicals-page">
        <div className="max-w-6xl mx-auto px-4">
          {/* Hero */}
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-center mb-16">
            <h1 className="font-['Barlow_Condensed'] text-5xl md:text-6xl font-bold uppercase text-[#0E3D95] mb-4">
              Spa <span className="text-[#F88200]">Chemicals</span>
            </h1>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto">Keep your hot tub water clean, clear, and safe with our premium spa chemicals</p>
          </motion.div>

          {/* Benefits */}
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.2 }} className="grid md:grid-cols-3 gap-8 mb-16">
            {[
              { icon: Shield, title: 'Safe & Effective', desc: 'Premium quality chemicals that are safe for you and your spa.' },
              { icon: Droplets, title: 'Crystal Clear Water', desc: 'Keep your water sparkling clean and inviting.' },
              { icon: Sparkles, title: 'Easy Maintenance', desc: 'Simple products that make spa care effortless.' }
            ].map((b, i) => (
              <div key={i} className="text-center p-6 bg-white/70 rounded-lg shadow-md">
                <b.icon className="mx-auto text-[#F88200] mb-3" size={36} />
                <h3 className="font-['Barlow_Condensed'] text-xl font-bold text-[#0E3D95] mb-2">{b.title}</h3>
                <p className="text-slate-600 text-sm">{b.desc}</p>
              </div>
            ))}
          </motion.div>

          {/* Products Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
            {products.map((product, idx) => (
              <motion.div
                key={idx}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: idx * 0.05 }}
                className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow"
                data-testid={`chemical-product-${idx}`}
              >
                <div className="aspect-video bg-gradient-to-br from-teal-50 to-blue-50 flex items-center justify-center p-4">
                  <img src={product.image} alt={product.name} className="h-32 w-auto object-contain" />
                </div>
                <div className="p-5">
                  <span className="text-xs font-semibold text-teal-600 uppercase tracking-wider">{product.category}</span>
                  <h3 className="font-['Barlow_Condensed'] text-lg font-bold text-[#0E3D95] mt-1 mb-2">{product.name}</h3>
                  <p className="text-slate-600 text-sm mb-3 line-clamp-2">{product.description}</p>
                  <p className="text-base font-bold text-[#F88200]">Call or email for pricing</p>
                </div>
              </motion.div>
            ))}
          </div>

          {/* Contact Form */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="bg-white rounded-xl shadow-xl overflow-hidden"
          >
            <div className="bg-gradient-to-r from-[#0E3D95] to-[#1E5DBF] p-6 text-white">
              <h2 className="font-['Barlow_Condensed'] text-3xl font-bold uppercase mb-2">Order Chemicals</h2>
              <p className="text-blue-100">Contact us to order spa chemicals or ask about our water care products</p>
            </div>
            <div className="p-6 md:p-8">
              {submitted ? (
                <motion.div
                  initial={{ opacity: 0, scale: 0.9 }}
                  animate={{ opacity: 1, scale: 1 }}
                  className="text-center py-8"
                >
                  <CheckCircle className="mx-auto text-green-500 mb-4" size={64} />
                  <h3 className="text-2xl font-bold text-[#0E3D95] mb-2">Thank You!</h3>
                  <p className="text-slate-600">We've received your inquiry and will contact you shortly.</p>
                </motion.div>
              ) : (
                <form onSubmit={handleSubmit} className="space-y-6">
                  <div className="grid md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-sm font-semibold text-slate-700 mb-2">
                        <User size={16} className="inline mr-2" />Name *
                      </label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-[#F88200] focus:border-transparent transition-all"
                        placeholder="Your name"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-semibold text-slate-700 mb-2">
                        <Mail size={16} className="inline mr-2" />Email *
                      </label>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-[#F88200] focus:border-transparent transition-all"
                        placeholder="your@email.com"
                      />
                    </div>
                  </div>
                  <div className="grid md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-sm font-semibold text-slate-700 mb-2">
                        <Phone size={16} className="inline mr-2" />Phone
                      </label>
                      <input
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-[#F88200] focus:border-transparent transition-all"
                        placeholder="(239) 555-1234"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-semibold text-slate-700 mb-2">Product Interest</label>
                      <select
                        name="productInterest"
                        value={formData.productInterest}
                        onChange={handleChange}
                        className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-[#F88200] focus:border-transparent transition-all"
                      >
                        <option value="">Select a category...</option>
                        <option value="sanitizers">Sanitizers (Chlorine/Bromine)</option>
                        <option value="balancers">pH & Alkalinity Balancers</option>
                        <option value="shock">Shock Treatments</option>
                        <option value="specialty">Specialty Products</option>
                        <option value="testing">Test Kits & Strips</option>
                        <option value="bundle">Complete Chemical Bundle</option>
                      </select>
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-semibold text-slate-700 mb-2">
                      <MessageSquare size={16} className="inline mr-2" />Message
                    </label>
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      rows={4}
                      className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-[#F88200] focus:border-transparent transition-all resize-none"
                      placeholder="Tell us what chemicals you need or any questions you have..."
                    />
                  </div>
                  <div className="flex flex-col sm:flex-row gap-4 items-center justify-between">
                    <p className="text-sm text-slate-500">
                      Or call us directly: <a href={`tel:${CONTACT.phone.replace(/[^0-9]/g, '')}`} className="font-semibold text-[#0E3D95] hover:text-[#F88200]">{CONTACT.phone}</a>
                    </p>
                    <button
                      type="submit"
                      className="btn-primary px-8 py-3 text-lg"
                    >
                      Send Inquiry
                    </button>
                  </div>
                </form>
              )}
            </div>
          </motion.div>

          {/* Free Chemicals Note */}
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="mt-12 text-center p-8 bg-gradient-to-r from-[#F88200]/10 to-[#0E3D95]/10 rounded-xl border-2 border-dashed border-[#F88200]/30"
          >
            <h3 className="font-['Barlow_Condensed'] text-2xl font-bold text-[#0E3D95] mb-2">
              🎁 FREE Chemicals with Every Hot Tub Purchase!
            </h3>
            <p className="text-slate-600">
              When you purchase a hot tub from Leisure Wellness Naples, you receive a starter chemical kit at no additional cost.
            </p>
          </motion.div>
        </div>
      </div>
    </>
  );
};

export default ChemicalsPage;
